import script from "./CrudToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudToolbar.vue?vue&type=script&setup=true&lang=js"

import "./CrudToolbar.vue?vue&type=style&index=0&id=462d7180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462d7180"]])

export default __exports__